module.exports = __webpack_public_path__ + "img/brand_statement_find_master.30b66201.webp";